const Header = {
	init() {
		const hamburger = document.querySelector(".menu-button");
		if (hamburger) {
			hamburger.addEventListener("click", function () {
				document.body.classList.toggle("nav-open");
			});
		}
	},
};

export default Header;
